import { SubscriptionCardTemplate, SubscriptionCardTemplateProps } from "./template";

export type SubscriptionCardProps = SubscriptionCardTemplateProps;

export const SubscriptionCard = (props: SubscriptionCardProps): JSX.Element => {
  return <SubscriptionCardTemplate {...props} />;
};
